import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getTop100Items, GetTop100ItemsApiParameter } from "@galarson/Handlers/Top100Items/Top100ItemsService";
import Top100ItemsState from "@galarson/Store/Top100Items/Top100ItemsState";

type HandlerType = ApiHandler<GetTop100ItemsApiParameter, Top100ItemsState>;

export const DispatchBeginLoadOrders: any = (props:any) => {
    props.dispatch({
        type: "Data/Top100Items/BeginLoadItems",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};


export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getTop100Items(props.apiParameter);
};

export const DispatchCompleteLoadOrders: any = (props:any) => {
    props.dispatch({
        type: "Data/Top100Items/CompletedLoadItems",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, DispatchBeginLoadOrders, RequestDataFromApi, DispatchCompleteLoadOrders];

const loadTop100Items = createHandlerChainRunner(chain, "Top100ItemsLoad");
export default loadTop100Items;
